import type { ReactNode } from "react";
import { ExpandableIndicator } from "@jetblue/kit/expandable-indicator";
import { HeaderMenuItem } from "./header-menu-item";

export type HeaderMenuProperties = {
  children?: ReactNode | undefined;
  isOpen: boolean;
  setOpen: () => void;
};
export const HeaderMenuButton = ({
  children,
  isOpen,
  setOpen,
}: HeaderMenuProperties) => (
  <HeaderMenuItem
    aria-expanded={isOpen}
    as="button"
    className="group/expandable-ui"
    onClick={setOpen}
  >
    <span className="flex w-full flex-row items-center justify-between text-s-heading focus-visible:outline-1 focus-visible:outline-offset-[3px] focus-visible:outline-white md:gap-2">
      {children}
      <ExpandableIndicator className="inline size-3" />
    </span>
  </HeaderMenuItem>
);
